module.exports = __webpack_public_path__ + "static/media/ic-flag.562bbe24.svg";